<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9165 3.33594H6.24984"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.9165 10H6.24984"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.9165 16.6641H6.24984"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <ellipse
      cx="1.04167"
      cy="1.04167"
      rx="1.04167"
      ry="1.04167"
      transform="matrix(-1 0 0 1 3.75 2.28906)"
      fill="currentColor"
    />
    <ellipse
      cx="1.04167"
      cy="1.04167"
      rx="1.04167"
      ry="1.04167"
      transform="matrix(-1 0 0 1 3.75 8.96094)"
      fill="currentColor"
    />
    <ellipse
      cx="1.04167"
      cy="1.04167"
      rx="1.04167"
      ry="1.04167"
      transform="matrix(-1 0 0 1 3.75 15.625)"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>